declare global {
  interface Window {
    YaPay?: YaPaySDK;
  }
}

export interface YaPaySDK {
  mountBadge: (
    element: Element,
    options: {
      type: 'bnpl' | 'cashback' | 'ultimate';
      amount: string;
      size?: 's' | 'm' | 'l';
      variant?: 'simple' | 'detailed' | 'default' | 'compact';
      color?: 'primary' | 'green' | 'grey' | 'transparent';
      theme?: 'light' | 'dark';
      align?: 'left' | 'right';
      merchantId: string;
    }
  ) => void;
}

let sdkPromise: Promise<YaPaySDK> | null = null;

export function loadYandexPaySdk(): Promise<YaPaySDK> {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Yandex Pay SDK requires window'));
  }

  if (window.YaPay) return Promise.resolve(window.YaPay);

  if (!sdkPromise) {
    sdkPromise = new Promise<YaPaySDK>((resolve, reject) => {
      const existing = document.querySelector(
        'script[src="https://pay.yandex.ru/sdk/v1/pay.js"]'
      ) as HTMLScriptElement | null;
      if (existing) {
        existing.addEventListener(
          'load',
          () => {
            if (window.YaPay) resolve(window.YaPay);
          },
          {
            once: true
          }
        );
        existing.addEventListener(
          'error',
          () => reject(new Error('Failed to load Yandex Pay SDK')),
          { once: true }
        );
      } else {
        const script = document.createElement('script');
        script.src = 'https://pay.yandex.ru/sdk/v1/pay.js';
        script.async = true;
        script.onload = () => {
          if (window.YaPay) resolve(window.YaPay);
        };
        script.onerror = () =>
          reject(new Error('Failed to load Yandex Pay SDK'));
        document.body.appendChild(script);
      }
    });
  }

  return sdkPromise;
}

export interface MountBnplBadgeOptions {
  element: Element;
  amount: number | null | undefined;
  size?: 's' | 'm' | 'l';
  variant?: 'simple' | 'detailed';
  color?: 'primary' | 'green' | 'grey' | 'transparent';
  theme?: 'light' | 'dark';
  align?: 'left' | 'right';
}

export async function mountBnplBadge({
  element,
  amount,
  size = 'm',
  variant = 'detailed',
  color = 'transparent',
  theme = 'light',
  align = 'left'
}: MountBnplBadgeOptions): Promise<void> {
  if (!amount || amount <= 0) return;

  const sdk = await loadYandexPaySdk();
  sdk.mountBadge(element, {
    type: 'bnpl',
    amount: amount.toFixed(2),
    merchantId: '4dec728c-ba96-42fa-b7ce-a7cd115130a9',
    size,
    variant,
    color,
    theme,
    align
  });
}
